import { Component, OnInit } from '@angular/core';
import { TppCommonService } from '@nspk/tpp-front-commons';
import { Router } from '@angular/router';

@Component({
    standalone: false,
    selector: 'app-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {

    constructor(
        private tppCommonService: TppCommonService,
        private router: Router
    ) {
    }

    ngOnInit(): void {
        if (!this.tppCommonService.getCookie('gsRequestError')) {
            this.router.navigate(['/']);
        } else {
            this.tppCommonService.deleteCookie('gsRequestError');
        }
    }

}
